import React, { useState, useEffect } from 'react';
import $, { event } from 'jquery'; 

export function LoginCierre({funcionFnumero , encendido, login, visibleTablaC, finalizaSesion})  {

var pasInput;   
var selInput;
function tecladoCierre( event, num ){
    pasInput = $('#pasC').val();       
    $('#pasC').val(pasInput+num);  
}

function borraCierreS(){
    pasInput = $('#pasC').val();
    pasInput= pasInput.slice(0,-1);  
    $('#pasC').val(pasInput);     
}
  
const cerrarMensaje=() =>{
    $("#pantallaLogin").show();
  }
  
  const setInput = ( event,inputL) =>{
    if(inputL==1){
      selInput=1;
    }else{
      selInput=2;
    }
} 
return(
    <table className='tablaCierreS' height='275px' width='490px' >
    <tbody>
      <tr>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_0_0.png' className='cierreS_0_0' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_0_1.png' className='cierreS_0_1'  /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_0_2.png' className='cierreS_0_2'  /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_0_3.png' className='cierreS_0_3'  /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_0_4.png' className='cierreS_0_4'  /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_0_5.png' className='cierreS_0_5' /></td>
    </tr>
      <tr>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_1_0.png' className='cierreS_1_0' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_1_1.png' className='cierreS_1_1'   /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_1_2.png' className='cierreS_1_2'   /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_1_3.png' className='cierreS_1_3'   /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_1_4.png' className='cierreS_1_4'   /></td>
        <td><img alt=' ' onClick={(event)=>cerrarMensaje(event)} src='assets/cierreSesion/cierreS_1_5.png'  className='cierreS_1_5'  /></td>
    </tr>
      <tr>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_2_0.png' className='cierreS_2_0' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_2_1.png' className='cierreS_2_1' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_2_2.png' className='cierreS_2_2' /></td>
        <td><img alt=' ' onClick={(event)=>tecladoCierre(event,1)} src='assets/cierreSesion/cierreS_2_3.png' className='cierreS_2_3' /></td>
        <td><img alt=' ' onClick={(event)=>tecladoCierre(event,2)} src='assets/cierreSesion/cierreS_2_4.png' className='cierreS_2_4' /></td>
        <td><img alt=' ' onClick={(event)=>tecladoCierre(event,3)} src='assets/cierreSesion/cierreS_2_5.png' className='cierreS_2_5' /></td>
    </tr>
    <tr>
        <td ><img alt=' ' src='assets/cierreSesion/cierreS_3_0.png' className='cierreS_3_0' /></td>
        <td ><img alt=' ' src='assets/cierreSesion/cierreS_3_1.png' className='cierreS_3_1' /></td>
        <td ><img alt=' ' onClick={(event)=>finalizaSesion(event)} src='assets/cierreSesion/cierreS_3_2.png' className='cierreS_3_2' /></td>
        <td><img alt=' ' onClick={(event)=>tecladoCierre(event,4)} src='assets/cierreSesion/cierreS_3_3.png' className='cierreS_3_3' /></td>
        <td><img alt=' ' onClick={(event)=>tecladoCierre(event,5)} src='assets/cierreSesion/cierreS_3_4.png' className='cierreS_3_4' /></td>
        <td><img alt=' ' onClick={(event)=>tecladoCierre(event,6)} src='assets/cierreSesion/cierreS_3_5.png' className='cierreS_3_5' /></td>
    </tr>
      <tr>
       <td rowSpan={2} bgcolor='#333333'><img alt=' ' src='assets/cierreSesion/cierreS_6_0.png' className='cierreS_6_0' /></td>
        <td rowSpan={2} bgcolor='#333333'>
            <input id='pasC' onFocus={(event)=>setInput(event,1)}  className='pasc'  type='text' />
            
        </td>
        <td rowSpan={2} bgcolor='#333333'><img alt=' ' onClick={ finalizaSesion }  src='assets/cierreSesion/cierreS_6_2.png' className='cierreS_6_2' /></td>
        <td  >
        <img alt=' ' onClick={(event)=>tecladoCierre(event,7)} src='assets/cierreSesion/cierreS_4_3.png' className='cierreS_4_3' /></td>
        <td  ><img alt=' ' onClick={(event)=>tecladoCierre(event,8)} src='assets/cierreSesion/cierreS_4_4.png' className='cierreS_4_4' /></td>
        <td  ><img alt=' ' onClick={(event)=>tecladoCierre(event,9)} src='assets/cierreSesion/cierreS_4_5.png' className='cierreS_4_5' /></td>
    </tr>	
      <tr>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_6_3.png' className='cierreS_6_3' /></td>
        <td><img alt=' ' onClick={(event)=>tecladoCierre(event,0)} src='assets/cierreSesion/cierreS_6_4.png' className='cierreS_6_4' /></td>
        <td><img alt=' ' onClick={(event)=>borraCierreS(event)} src='assets/cierreSesion/cierreS_6_5.png' className='cierreS_6_5' /></td>
    </tr>
     <tr>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_8_0.png' className='cierreS_8_0' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_8_1.png' className='cierreS_8_1' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_8_2.png' className='cierreS_8_2' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_8_3.png' className='cierreS_8_3' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_8_4.png' className='cierreS_8_4' /></td>
        <td><img alt=' ' src='assets/cierreSesion/cierreS_8_5.png' className='cierreS_8_5' /></td>
    </tr>	
</tbody>	
</table> 
  );
};